export const SET_searchInputValue = 'SET_SEARCH_INPUT_VALUE'
export const SET_title = 'SET_TITLE'
export const SET_tabbarIndex = 'SET_TABBAR_INDEX'
export const SET_userSexMan = 'SET_USER_SEX_MAN'
export const SET_userSexWomen = 'SET_USER_SEX_WOMEN'
export const SET_userSexDefault = 'SET_USER_SEX_DEFAULT'
export const SET_userAddress = 'SET_USER_ADDRESS'
export const UPDATE_loadingStatus = 'UPDATE_LOADING_STATUS'
export const SET_avatar = 'SET_AVATAR'
export const SET_name = 'SET_NAME'
export const SET_nickName = 'SET_NICKNAME'
export const SET_mobile = 'SET_MOBILE'
export const SET_orgLogo = 'SET_ORGLOGO'
export const SET_baseurl = 'SET_BASEURL'
export const SET_userLoginOut = 'SET_USER_LOGIN_OUT'
export const SET_userLoginIn = 'SET_USER_LOGIN_IN'
export const SET_userBindingOut = 'SET_USER_BINDING_OUT'
export const SET_userBindingIn = 'SET_USER_BINDING_IN'
export const SET_type = 'SET_TYPE'
export const SET_orgName = 'SET_ORGNAME'


// WEBPACK FOOTER //
// ./src/store/mutations-type.js